import React from 'react';
import { Box } from '@mui/material';
import { useCategoryContext } from '../contexts/CategoryContext';
import { ViewMode } from '../hooks/useViewMode';
import MainContentArea from './MainContentArea';
import NotesListBody from './NotesListBody';
import NoteEditorBody from './NoteEditorBody';
import TrashView from './TrashView';

interface AppBodyProps {
  viewMode?: ViewMode;
  /** Create a note in the current note category (wired by the layout, task 15). */
  onAddNote?: () => void;
}

/**
 * Routes the main body based on the unified selection:
 *  - notes Trash            → TrashView
 *  - notes + selected note  → NoteEditorBody (full-body editor)
 *  - notes + category       → NotesListBody
 *  - bookmarks              → MainContentArea (unchanged)
 */
const AppBody: React.FC<AppBodyProps> = ({ viewMode, onAddNote }) => {
  const { activeApp, selectedNote, notesTrashOpen } = useCategoryContext();

  if (activeApp === 'notes') {
    if (notesTrashOpen) {
      return <TrashView />;
    }
    if (selectedNote) {
      // Relative wrapper so the editor can absolute-fill and own its scroll,
      // independent of the layout's outer auto-overflow box.
      return (
        <Box sx={{ position: 'relative', height: '100%' }}>
          {/* key per note: fresh model + editor instance on every note switch,
              avoids stale content carry-over and ProseMirror teardown races. */}
          <NoteEditorBody key={selectedNote.note_id} note={selectedNote} />
        </Box>
      );
    }
    return <NotesListBody onAddNote={onAddNote} />;
  }

  return <MainContentArea viewMode={viewMode} />;
};

export default AppBody;
